import { GET_GRANTED_AUTHORITIES } from 'web-library/constants/queryKeys';
import { GET_USER_AUTHORITIES_URL } from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';

export const useGetUserAuthorities = () => {
  const getUserAuthorities = async () => {
    const res = await axiosClient.get<string[]>(GET_USER_AUTHORITIES_URL);
    return res.data;
  };

  return useCustomQuery(GET_GRANTED_AUTHORITIES, getUserAuthorities, {
    staleTime: Infinity,
  });
};
